"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBScdPositive = function SvgBScdPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M66.346 131.44a2.262 2.262 0 01-2.262-2.262v-12.176a2.262 2.262 0 114.523 0v12.176a2.262 2.262 0 01-2.261 2.262zM66.346 77.948a2.262 2.262 0 01-2.262-2.261V63.624a2.262 2.262 0 014.523 0v12.063a2.262 2.262 0 01-2.261 2.261z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M66.346 117.794a13.375 13.375 0 01-9.221-3.567 2.262 2.262 0 013.099-3.294 8.859 8.859 0 006.122 2.337c4.614 0 8.368-3.28 8.368-7.313 0-4.358-4.305-6.982-8.557-7.328a17.182 17.182 0 01-4.523-.965c-5.037-2.02-8.158-6.19-8.158-10.864v-.098a11.309 11.309 0 013.86-8.452 13.737 13.737 0 0118.094 0 2.262 2.262 0 11-3.015 3.347 9.228 9.228 0 00-12.018 0A6.823 6.823 0 0058 86.702v.075c0 2.835 1.99 5.33 5.322 6.672 1.044.353 2.128.571 3.227.649 7.358.603 12.704 5.579 12.704 11.821 0 6.567-5.783 11.875-12.907 11.875z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M98.342 129.2a2.262 2.262 0 01-2.262-2.261v-63.12a2.262 2.262 0 014.524 0v63.12a2.262 2.262 0 01-2.262 2.261zM34.311 129.2a2.262 2.262 0 01-2.262-2.261v-63.12a2.262 2.262 0 014.524 0v63.12a2.262 2.262 0 01-2.262 2.261zM20.228 50.641a2.262 2.262 0 01-1.598-3.86L64.747.663a2.262 2.262 0 013.197 0l46.118 46.118a2.262 2.262 0 11-3.197 3.197l-44.52-44.52-44.481 44.52a2.262 2.262 0 01-1.636.663z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M48.477 40.207a2.262 2.262 0 01-1.598-3.86L64.747 18.47a2.345 2.345 0 013.204 0l16.76 16.768a2.266 2.266 0 01-3.196 3.211l-15.17-15.176-16.27 16.27a2.262 2.262 0 01-1.598.663zM20.002 129.2a2.262 2.262 0 01-2.262-2.261V62.795a2.262 2.262 0 012.262-2.262h101.026v-9.71H11.603v12.16a2.262 2.262 0 11-4.524 0V48.56A2.262 2.262 0 019.341 46.3h113.971a2.262 2.262 0 012.262 2.261v14.235a2.262 2.262 0 01-2.262 2.261H22.286v61.883a2.262 2.262 0 01-2.284 2.262z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M112.652 129.2a2.262 2.262 0 01-2.262-2.261V62.795a2.262 2.262 0 114.524 0v64.144a2.262 2.262 0 01-2.262 2.261z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M123.38 132.744H9.35a2.262 2.262 0 110-4.524H123.38a2.262 2.262 0 010 4.524zM130.603 143.54H2.262a2.262 2.262 0 010-4.523h128.34a2.262 2.262 0 010 4.523z",
    fill: "#285"
  })));
};

var _default = SvgBScdPositive;
exports["default"] = _default;